import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => {
  return {
    accordion: {
      "& .MuiAccordion-root": {
        border: `1px solid ${theme.palette.background.gray_200}`,
        borderRadius: "12px",
        boxShadow: "none",
      },
      "& .MuiCollapse-wrapper": {
        backgroundColor: theme.palette.background.gray_50,
      },
      [theme.breakpoints.down("864")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        "& .MuiAccordionSummary-expandIcon": {
          display: "none",
        },
        "& .MuiAccordionSummary-content": {
          flexDirection: "column",
          gap: "20px",
        },
      },
    },
    cardContainer: {
      padding: "20px",
      width: "100%",
      borderRadius: "12px",
      backgroundColor: theme.palette.background.paper,
    },
    highlight: {
      "& .MuiAccordion-root": {
        border: `1px solid ${theme.palette.primary.main}`,
        overflow: "hidden",
      },
    },
    expandText: {
      fontSize: "16px",
      fontWeight: 600,
      color: theme.palette.text.tertiary,
      marginRight: "8px",
      display: "none",
      [theme.breakpoints.down("864")]: {
        display: "block",
      },
    },
    icon: {
      transform: "rotate(0deg)",
      transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      display: "none",
      [theme.breakpoints.down("864")]: {
        display: "block",
      },
    },
    iconActive: {
      transform: "rotate(180deg)",
      transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  };
});
